import React from 'react';
import styled from 'styled-components';

const AbsoluteContainer = styled.div`
  display: flex;
  justify-content: center;
  //width: 100%;
  padding: 12px 24px;
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -142px;
  width: 284px;
`;

export default AbsoluteContainer;
